import { Typography } from '@mui/material'

export const NoDataMessage = () => (
  <Typography color="text.secondary" component="span">
    No Data Available
  </Typography>
)
